import { translatePaymentMethodName } from 'mmfintech-commons'

import MethodImage from './MethodButton/MethodImage'

interface MethodPaneProps {
  method: string
}

const MethodPane = ({ method }: MethodPaneProps) =>
  method ? (
    <div className='method-container'>
      <span>{translatePaymentMethodName(method)}</span>
      <MethodImage method={method} className='icon' />
    </div>
  ) : null

export default MethodPane
